import * as yup from 'yup';

const addContentsModalFormValidation = yup.object().shape({
  title: yup.string().trim().required('Title  is a required field'),
  description: yup.string().trim().label('Description'),
  contentUrl: yup.string().trim().required('Media file is a required field').test({
    name: 'test-url',
    test(value) {
      if (!value?.startsWith('https://')) {
        return this.createError({ path: 'contentUrl', message: 'Please enter a secured file URL that start with https://' });
      }
      if (value?.startsWith('https://youtu') || value?.startsWith('https://vimeo')) {
        return this.createError({ path: 'contentUrl', message: 'This file URL is not supported' });
      }
      return true;
    },
  }),
  fileType: yup.string().trim().required('Media file type is a required field'),
  isExternalFile: yup.boolean(),
  fileCategory: yup.string().trim().optional(),
  thumbnailGenerated: yup.string().trim().when(['isExternalFile', 'fileCategory'], {
    is: (isExternalFile: boolean, fileCategory: string) => isExternalFile && fileCategory === 'video',
    then: yup
      .string()
      .trim()
      .required('Generate a video preview thumbnail')
      .label('Thumbnail'),
  }),
});
export default addContentsModalFormValidation;
